import {
  Component,
  forwardRef,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NzSizeLDSType } from 'ng-zorro-antd/core/types';

import {
  TtcSegmentedOption,
  ttcSegmentedSizeDefault,
} from './ttc-segmented.types';
import { fadeInEnter } from '@libs/src/animations/animations';

import defer from 'lodash-es/defer';

@Component({
  animations: [fadeInEnter],
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TtcSegmentedComponent),
    },
  ],
  selector: 'app-ttc-segmented',
  templateUrl: './ttc-segmented.component.html',
})
export class TtcSegmentedComponent implements ControlValueAccessor, OnChanges {
  @Input() enableAnalytics = false;
  @Input() options: TtcSegmentedOption[] = [];
  @Input() disabled = false;
  @Input() selected: TtcSegmentedOption;
  @Input() showCheckIcon = true;
  @Input() size: NzSizeLDSType = ttcSegmentedSizeDefault;
  selectedIndex = 0;
  onChanged: (value: TtcSegmentedOption) => void = () => {};
  onTouched: () => void = () => {};

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selected?.currentValue) {
      const targetIndex = this.options?.findIndex(
        (option) => option.value === this.selected.value,
      );
      defer(() => {
        this.selectedIndex = Math.max(targetIndex, 0);
        this.writeValue(this.options[this.selectedIndex]);
      });
    }
  }

  handleModelChange(changedIndex: number) {
    this.writeValue(this.options[changedIndex]);
  }

  registerOnChange(
    onChangeFunction: (value: TtcSegmentedOption) => void,
  ): void {
    this.onChanged = onChangeFunction;
  }

  registerOnTouched(onTouchedFunction: () => void): void {
    this.onTouched = onTouchedFunction;
  }

  writeValue(item: TtcSegmentedOption): void {
    this.onChanged(item);
  }
}
